import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'start',
      component: () => import('@/views/start')
    },
    {
      path: '/start',
      name: 'start',
      component: () => import('@/views/start')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index')
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/views/mine')
    },
    {
      path: '/ranking',
      name: 'ranking',
      component: () => import('@/views/ranking')
    },
    {
      path: '/score',
      name: 'score',
      component: () => import('@/views/score')
    },
    {
      path: '/task',
      name: 'task',
      component: () => import('@/views/task')
    },
    {
      path: '/topic_start',
      name: 'topic_start',
      component: () => import('@/views/topic_start')
    },
    {
      path: '/topic',
      name: 'topic',
      component: () => import('@/views/topic')
    },
    {
      path: '/my_team',
      name: 'my_team',
      component: () => import('@/views/my_team')
    },
    {
      path: '/week_task',
      name: 'week_task',
      component: () => import('@/views/week_task')
    },
    {
      path: '/publish_sport_circle',
      name: 'publish_sport_circle',
      component: () => import('@/views/publish_sport_circle')
    },
    {
      path: '/sport_circle',
      name: 'sport_circle',
      component: () => import('@/views/sport_circle')
    },
    {
      path: '/match_share',
      name: 'match_share',
      component: () => import('@/views/match_share')
    },
    {
      path: '/team_share',
      name: 'team_share',
      component: () => import('@/views/team_share')
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/calendar')
    },
    {
      path: '/run_list',
      name: 'run_list',
      component: () => import('@/views/run_list')
    },
    {
      path: '/create_run',
      name: 'create_run',
      component: () => import('@/views/create_run')
    },
    {
      path: '/add_score',
      name: 'add_score',
      component: () => import('@/views/add_score')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js